import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Log } from 'ng2-logger';

@Component({
    selector: 'app-audits-form',
    templateUrl: './audits-form.component.html',
    styleUrls: ['./audits-form.component.scss']
})
export class AuditsFormComponent implements OnInit {
    _logger = Log.create(AuditsFormComponent.name);

    @Input() entities: any;

    @Output() entityChange = new EventEmitter<any>();
    @Output() formChange = new EventEmitter<any>();
    @Output() download = new EventEmitter<any>();

    getAuditsForm: UntypedFormGroup;

    showValidations = false;

    constructor(private formBuilder: UntypedFormBuilder) {
    }

    ngOnInit() {
        this.getAuditsForm = this.formBuilder.group({
            entity: ['', Validators.required],
            startDate: [null, Validators.required],
            endDate: [null, Validators.required]
        });

        setTimeout(() => {
            this.subscribeToFormValueChanges();
            this.getAuditsForm.controls['entity'].setValue('tools');
        });
    }

    subscribeToFormValueChanges() {
        this.getAuditsForm.valueChanges.subscribe(formValue => {
            this._logger.info("onFormChanges:: ", formValue);

            const filters = [];
            Object.keys(formValue).forEach(key => {
                const filter = {
                    field: key,
                    value: formValue[key]
                };
                if (filter.value) {
                    filters.push(filter);
                }
            });

            this.formChange.emit(filters);
        });
    }

    onEntityChange(value) {
        this.entityChange.emit(value);
    }

    onDownload() {
        this.download.emit(this.getAuditsForm.value);
    }
}
